import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../../layout/breadcrumb";
import formatedDate, {
    formattedDateOnly,
} from "../../../utilities/formatedDate";
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Table,
} from "reactstrap";
import FirstLoginTour from "../../../utilities/firrstLoginTour";
import Tour from "reactour";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import {
    getAllTcDocumentData,
    getBpKycMisReport
} from "../../../api";
import { toast } from "react-toastify";
import { FormProvider, useForm } from "react-hook-form";
import RequiredIndicator from "../../partial/RequiredIndicator";
import DateRangePicker from "../../datepickers/DateRangePicker";

const BpGstVerificationReport = () => {

const submitForm = async (data) => {
    setIsSubmitting(true);

    try {
        const requestData = {
            start_date: data.start_date?.substring(0, 10),
            end_date: data.end_date?.substring(0, 10),
        };

        if (!requestData.start_date || !requestData.end_date) {
            toast.error("Start date and end date are required");
            return;
        }

        // console.log("Before API Call");

        const res = await getBpKycMisReport(requestData);

        // console.log("API Response:", res);

        toast.success(
            res?.data?.message ||
            res?.message ||
            "Report generated successfully"
        );

        reset();
    } catch (err) {
        console.error("API Error:", err);

        toast.error(
            err?.response?.data?.message ||
            err?.response?.data?.error ||
            err?.message ||
            "Something went wrong"
        );
    } finally {
        setIsSubmitting(false);
    }
};

const {
    register,
    handleSubmit,
    formState,
    getValues,
    reset
} = useForm();

const [opentour, setopentour] = useState(FirstLoginTour());
const [isSubmitting, setIsSubmitting] = useState(false);

const closeTour = () => {
    setopentour(false);
};
const disableBody = (target) => disableBodyScroll(target);
const enableBody = (target) => enableBodyScroll(target);

const topFunction = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
};
    return (
        // <h1>GST VERIFICATION REPORT</h1>
        <Fragment>
            <Breadcrumb parent="Reports" title="Document Report" />
           
            <Container fluid={true}>
                <Row>
                    <Col lg="12 box-col-12" xl="6 xl-100">
                        <Card
                            className="height-equal step1"
                            data-intro="This is where you can add product to Affiliators"
                        >
                            <CardBody className="tabbed-card body_with_low_padding">
                                <FormProvider>
                                    <Form
                                        onSubmit={handleSubmit(submitForm)}
                                    >
                                        <FormGroup className="col-md-12">
                                            <Row>
                                                <Col>
                                                    <Row>
                                                        <Col sm="8" md="8" lg="8">
                                                            <Label>{"Date Range"}</Label>
                                                            <RequiredIndicator />
                                                            <DateRangePicker
                                                                className="form-control digits"
                                                                nameForStartDate="start_date"
                                                                nameForTillDate="end_date"
                                                                register={register}
                                                                getValues={getValues}
                                                                formState={formState}
                                                            />
                                                        </Col>
                                                    </Row>

                                                    <Row className="pt-4">
                                                        <Col sm="12" className="text-right mt-4">
                                                            <div>
                                                                <Button
                                                                    color="info"
                                                                    className=" btn-gradient"
                                                                    data-intro="This is where you can generate new MIS report "
                                                                    disabled={isSubmitting}
                                                                >
                                                                    {isSubmitting ? "Loading..." : "Generate"}
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <FormGroup className="col-md-12">
                                                        <Row>
                                                            <Col></Col>
                                                        </Row>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                    </Form>
                                </FormProvider>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default BpGstVerificationReport;